import styled from 'styled-components';

const FormGroup = styled('div')`
  position: relative;
  span.errorMsg {
    position: absolute;
    bottom: -30px;
    right: 0;
    font-size: 12px;
    color: red;
    opacity: 0;
    visibility: hidden;
    transform: scale(0.96);
    transition: all 300ms ease-out;
  }
  &.hasErrorMsg {
    span.errorMsg {
      opacity: 1;
      visibility: visible;
      transform: scale(1);
      bottom: -22px;
      right: 0;
    }
  }
`;

export default FormGroup;
